// Initializes the fielstyle plugin
import * as angular from 'angular';

function fillElement() {
    return {
        restrict: 'A',
        link: link
    };

    function link(scope: ng.IScope, $element: JQLite & any) {
        scope.$watch(function () {
                return $(window).height();
            },
            function() {
                const height = $(window).height();
                const elemHeightOffset = $element.offset().top;
                const footerHeight = $('.app-footer').height();
                const elemCalcHeight = height - elemHeightOffset - footerHeight;
                $element.height(elemCalcHeight);
            });
    }
}

angular.module('app.common').directive('fillElement', fillElement);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/directives/fillElement.directive.ts